export const TOKEN_SESSION_KEY = 'cimb_token'
export const USER_SESSION_EKY = 'cimb_user'
export const SMS_EXPIRING = 2 * 60
export const ROOT_PATH = ''
export const PORTOAL_LOGIN_LINK = 'https://e-shenma.com.my/portal/'
export const MERCHANT_LOGIN_LINK = 'https://e-shenma.com.my/login'
export const MOTORLOAN_LINK = 'https://www.motorloan.my'
export const INSURANCE_MOTOR_LINK = 'https://getquote.allianz.com.my/motorcycle-plus/get-info?utm_source=AGSC16312'
export const INSURANCE_CAR_LINK = 'https://getquote.allianz.com.my/motor-online/get-info?utm_source=AGSC16312'
export const FACEBOOK_LINK = 'https://www.facebook.com/SHENMACredit'
export const YOUTUBE_LINK = 'https://www.youtube.com/@shenmacreditsdnbhd'
export const INSTAGRAM_LINK = 'https://www.instagram.com/shenma_credit/'
export const PRIVACY_LINK = 'https://smilx-prod.oss-ap-southeast-3.aliyuncs.com/mobile/pf_pdf/Clean%20Personal%20Data%20and%20Privacy%20Policy%20(Shenma%20Credit).pdf'
export const TERMS_LINK = 'https://smilx-prod.oss-ap-southeast-3.aliyuncs.com/mobile/pf_pdf/Terms%20and%20Conditions%20%5BOnline%20Money%20Lending%5D%20-%20Shenma.pdf'
export const GOOGLE_PLAY_STORE_LINK = 'https://play.google.com/store/apps/details?id=com.shenma.customer_portal&pli=1'
export const APP_STORE_LINK = 'https://apps.apple.com/my/app/shenma-mobile/id1565901986'
export const APP_GALLERY_LINK = 'https://appgallery.huawei.com/#/app/C103882667'
export const App_Language_key = 'App_Language_key'
export const PRODUCT_DISCLOSURE_LINK = 'https://smilx-prod-oss.e-shenma.com.my/motorloan/SHENMA-HP-PRODUCT-DISCLOSURE-SHEET_V0.3.pdf'